import axios from 'axios';

export function getLrs() {
  return axios.get('lrs');
}
